import React from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import NumberFormat from "react-number-format";

import { getLoggedProfile } from "../../model/profile";

import { commonErr } from "../../components/common/errors";
import { RegistryType } from "../../components/common/common";

import { LoadingInline, LoadingPage } from "../common/loading";

import fourSeat from "../../static/images/vehicle-type/4.png";
import sevenSeat from "../../static/images/vehicle-type/7.png";
import pickupTruck from "../../static/images/vehicle-type/1.png";
import pti from "../../static/images/insurance/anonymous/pti.png";
import { Tooltip } from "../common/svg";

const REGISTER = {
	BUSSINESS: 2,
	NO_BUSSINESS: 1,
};
const VTYPE = {
	FOUR: 1,
	SEVEN: 2,
	PTRUCK: 7,
};
class TNDSBox extends React.Component {
	state = {
		err: commonErr.INNIT,
		errMsg: "",
		showPkgPrice: true,
		buySeat: true,
	};

	componentDidMount() {}

	componentDidUpdate(preProps) {
		if (preProps.regType !== this.props.regType) {
			this.setState({
				regType:
					this.props.regType === 3 || this.props.regType === 2 || this.props.regType === 4
						? REGISTER.BUSSINESS
						: REGISTER.NO_BUSSINESS,
				vehicleType: this.props.vehicleType,
			});
		}

		if (preProps.vehicleType !== this.props.vehicleType) {
			this.setState({
				regType: this.props.regType,
				vehicleType: this.props.vehicleType,
			});
		}
	}

	getTNDSPrice = (regType, vehicleType, buySeat) => {
		this.props.getTNDS(regType, vehicleType, buySeat);
	};

	onRegTypeChange = (id) => {
		this.setState({
			regType: id,
			showPkgPrice: false,
		});
	};

	onVehicleTypeChange = (id) => {
		this.setState({
			vehicleType: id,
			showPkgPrice: false,
		});
	};

	onBuySeatChange = () => {
		const { regType, vehicleType } = this.state;
		const buySeat = !this.state.buySeat;
	

		this.setState({
			buySeat,
			err: commonErr.SUCCESS,
		});
		this.getTNDSPrice(regType, vehicleType, buySeat);
	};

	onSubmit = () => {
		const { regType, vehicleType, buySeat } = this.state;

		this.getTNDSPrice(regType, vehicleType, buySeat);
		this.setState({
			showPkgPrice: true,
		});
	};

	close = () => {
		const { regType, vehicleType, buySeat } = this.state;
		const { price } = this.props.ins;

		this.props.getTNDSParams(buySeat, vehicleType, regType, price);
		this.props.hide();
	};

	render() {
		let content;
		const { err } = this.props.ins;
		const { vehicleType, regType, showPkgPrice, buySeat } = this.state;

		if (err === commonErr.LOADING) {
			content = <LoadingPage />;
		} else if (err >= commonErr.SUCCESS) {
			const { price, discountsTNDS } = this.props.ins;

			content = (
				<>
					<div className="title-ins">
						<h5>Mục đích sử dụng</h5>
					</div>
					<div className="list-option">
						<div className="option-2 custom-radio">
							<input
								type="radio"
								id="regType2"
								name="regType"
								value={REGISTER.BUSSINESS}
								checked={regType === REGISTER.BUSSINESS}
								onChange={() => this.onRegTypeChange(REGISTER.BUSSINESS)}
							/>
							<label htmlFor="regType2">Kinh doanh</label>
						</div>
						<div className="option-2 custom-radio">
							<input
								type="radio"
								id="regType1"
								name="regType"
								value={REGISTER.NO_BUSSINESS}
								checked={regType === REGISTER.NO_BUSSINESS}
								onChange={() => this.onRegTypeChange(REGISTER.NO_BUSSINESS)}
							/>
							<label htmlFor="regType1">Không kinh doanh</label>
						</div>
					</div>
					<div className="space l">
						<div className="title-ins">
							<h5>Loại Xe</h5>
						</div>
						<div className="vehicle-types">
							<div className="custom-radio">
								<input
									type="radio"
									id="vehicle-types-1"
									name="vehicle-types"
									value={VTYPE.FOUR}
									checked={vehicleType === VTYPE.FOUR}
									onChange={() => this.onVehicleTypeChange(VTYPE.FOUR)}
								/>
								<label htmlFor="vehicle-types-1">Xe 4-5 chỗ</label>
							</div>
							<div className="custom-radio">
								<input
									type="radio"
									id="vehicle-types-2"
									name="vehicle"
									value={VTYPE.SEVEN}
									checked={vehicleType === VTYPE.SEVEN}
									onChange={() => this.onVehicleTypeChange(VTYPE.SEVEN)}
								/>
								<label htmlFor="vehicle-types-2">Xe 7 chỗ</label>
							</div>
							<div className="custom-radio">
								<input
									type="radio"
									id="vehicle-types-7"
									name="vehicle"
									value={VTYPE.PTRUCK}
									checked={vehicleType === VTYPE.PTRUCK}
									onChange={() => this.onVehicleTypeChange(VTYPE.PTRUCK)}
								/>
								<label htmlFor="vehicle-types-7">Bán tải</label>
							</div>
						</div>
					</div>
					{!showPkgPrice && (
						<div className="btn-center space l">
							<button className="btn btn-primary" onClick={this.onSubmit}>
								Báo phí sản phẩm bảo hiểm
							</button>
						</div>
					)}
					{showPkgPrice && (
						<>
							{this.props.ins.err === commonErr.SUCCESS ? (
								<div className="insurance-quote">
									<div className="d-flex-align-center">
										<h6>
											{vehicleType === VTYPE.FOUR
												? "Xe 4 - 5 chỗ"
												: vehicleType === VTYPE.SEVEN
												? "Xe 7 chỗ"
												: "Bán tải"}
										</h6>
										<p className="type-ins marginLeft-xs">
											{regType === REGISTER.BUSSINESS ? "Kinh doanh" : "Không kinh doanh"}
										</p>
									</div>
									<div className="ins-price-box">
										<div className="ins-price-extra">
											<div className="ins-price-title">
												<div className="unit">
													<p>Đơn vị tính: VNĐ</p>
												</div>
												<div className="title-1">
													<h5>Số Tiền Bảo Hiểm</h5>
												</div>
												<div className="title-2">
													<div className="benefit">
														<h6>Quyền Lợi Bảo Hiểm</h6>
													</div>
													<div className="rules">
														<div className="box-m">
															<p className="fontWeight-5">A. BH TNDS BẮT BUỘC</p>
														</div>
														<div className="box-l">
															<div className="option-ins">
																<div className="custom-checkbox-selected">
																	<input type="checkbox" id="tnds1" name="tnds1" disabled defaultChecked />
																	<label htmlFor="tnds1">Bảo hiểm trách nhiệm cho bên thứ 3</label>
																</div>
																<div className="tooltip">
																	<div className="wrap-svg">
																		<Tooltip />
																	</div>
																	<div className="tooltip-text">
																		Nhà bảo hiểm thay mặt chủ xe bồi thường các tổn thất về người và tài sản cho bên thứ
																		ba (bên bị thiệt hai do xe của chủ xe gây ra).
																		<br />
																		Về người: tối đa 150 triệu đồng/người /vụ.
																		<br />
																		Về tài sản: theo tổn thất thực tế, tối đa 100.000.000đ.
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div className="rules">
														<div className="box-m">
															<p className="fontWeight-5">B. ĐIỀU KHOẢN BỔ SUNG</p>
														</div>
														<div className="box-l">
															<div className="custom-checkbox-selected">
																<input
																	type="checkbox"
																	id="tnds2"
																	name="tnds1"
																	value={buySeat}
																	checked={buySeat}
																	onChange={this.onBuySeatChange}
																/>
																<label htmlFor="tnds2">Bảo hiểm người ngồi trên xe</label>
															</div>
															<div className="tooltip">
																<div className="wrap-svg">
																	<Tooltip />
																</div>
																<div className="tooltip-text">
																	Nhà bảo hiểm bồi thường thiệt hại về thân thể đối với lái xe và người được chở trên xe
																	với điều kiện những người này bị tai nạn khi đang ở trên xe, lên xuống xe trong quá
																	trình xe ô tô đang tham gia giao thông. Mức trách nhiệm 10 triệu đồng/người/vụ.
																</div>
															</div>
															{/* <div className="option-ins have-change" onClick={this.onBuySeatChange}>
																{buySeat ? (
																	<i className="ic ic-black-circle active" />
																) : (
																	<i className="ic ic-black-circle" />
																)}
															</div> */}
														</div>
													</div>
													<div className="total-price-ins">
														<div className="box-m" />
														<div className="box-l">
															<p className="fontWeight-5">Tổng phí</p>
															<p className="fontWeight-5">Tổng phí (gồm 10% VAT)</p>
															{discountsTNDS &&
																discountsTNDS.map((discount, i) => {
																	return (
																		<p className="fontWeight-5" key={i}>
																			{discount.name}
																		</p>
																	);
																})}
															<p className="price-total">TỔNG PHÍ ĐÃ GIẢM (gồm 10% VAT)</p>
														</div>
													</div>
												</div>
											</div>
											<div className="ins-price-company">
												<div className="ins-company">
													<img loading="lazy" className="img-fluid" src={pti} style={{ margin: "0 0 5px 0" }} />
													<h6>Bảo Hiểm PTI</h6>
												</div>
												<div className="package w-100">
													<div>
														<h6>
															{
																<NumberFormat
																	value={price.insurancePrice}
																	displayType={"text"}
																	thousandSeparator={" "}
																	decimalSeparator={","}
																/>
															}
														</h6>
														<p>/người/vụ</p>
													</div>
													<div className="line-bottom" />
													<div className="space ins" />
													<div className="line-bottom" />
													<p className="price-extra">
														<NumberFormat
															value={price.requiredPrice}
															displayType={"text"}
															thousandSeparator={" "}
															decimalSeparator={","}
														/>
													</p>
													<div className="line-bottom" />
													<p className={`${buySeat ? "" : "price-unselected"}`}>
														<NumberFormat
															value={price.seatPrice.price}
															displayType={"text"}
															thousandSeparator={" "}
															decimalSeparator={","}
														/>
													</p>
													<div className="line-bottom" />
													<p className="fontWeight-5">
														<NumberFormat
															value={price.priceTotal}
															displayType={"text"}
															thousandSeparator={" "}
															decimalSeparator={","}
														/>{" "}
													</p>
													<p className="fontWeight-5">
														<NumberFormat
															value={price.priceTotalVAT}
															displayType={"text"}
															thousandSeparator={" "}
															decimalSeparator={","}
														/>{" "}
													</p>
													{price.discounts &&
														price.discounts.map((discount, i) => {
															return (
																<p className="text-danger cost" key={i}>
																	-
																	<NumberFormat
																		value={discount.price}
																		displayType={"text"}
																		thousandSeparator={" "}
																		decimalSeparator={","}
																	/>
																</p>
															);
														})}
													<p className="price-total">
														<NumberFormat
															value={price.priceFinal}
															displayType={"text"}
															thousandSeparator={" "}
															decimalSeparator={","}
														/>
													</p>
													<div className="btn btn-primary" onClick={this.close}>
														Chọn mua
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							) : (
								<div>Thông tin không phù hợp</div>
							)}
						</>
					)}
				</>
			);
		}

		return (
			<Modal show={this.props.isShow} onHide={this.close} dialogClassName="modal-l modal-dialog modal-insurance-tnds">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>Bảo hiểm trách nhiệm dân sự bắt buộc</h5>
				</Modal.Header>
				<Modal.Body>{content}</Modal.Body>
			</Modal>
		);
	}
}

function mapState(state) {
	return {
		ins: state.ins,
	};
}

TNDSBox = connect(mapState)(TNDSBox);

export default TNDSBox;
